import { InvoiceStatus } from '@constants'
import {
  FaCheckCircle,
  FaClock,
  FaEnvelope,
  FaFeatherAlt,
  FaGavel,
  FaMinusCircle,
  FaPaperPlane,
  FaRegPaperPlane,
  FaShare,
  FaStamp
} from 'react-icons/fa'
import type { IconType } from 'react-icons'

/** Invoicing list row and source-invoice preview (sales). */
export const SalesInvoiceListIcon: IconType = FaShare

/** Invoicing list row and source-invoice preview (purchase). */
export const PurchaseInvoiceListIcon: IconType = FaEnvelope

/** Invoice delivered to the recipient. */
export const InvoiceSentIcon: IconType = FaPaperPlane

/** Confirmed but not yet delivered. */
export const InvoiceNotSentIcon: IconType = FaPaperPlane

/** Confirmed, sendable, waiting for user to send. */
export const InvoiceReadyToSendIcon: IconType = FaRegPaperPlane

export const getInvoiceDeliveryIcon = (sent: boolean): IconType =>
  sent ? InvoiceSentIcon : InvoiceNotSentIcon

/** Icons for {@link InvoiceStatusBadge} lifecycle states. */
export const invoiceStatusIcons: Record<InvoiceStatus, IconType> = {
  [InvoiceStatus.DRAFT]: FaFeatherAlt,
  [InvoiceStatus.ACCEPTED]: FaStamp,
  [InvoiceStatus.CREDIT_LOSS]: FaMinusCircle,
  [InvoiceStatus.PAID]: FaCheckCircle
}

export const PurchaseInvoicePaidIcon: IconType = FaCheckCircle
export const PurchaseInvoiceUnpaidIcon: IconType = FaClock

export const InvoiceDebtCollectionIcon: IconType = FaGavel
export const InvoiceSoftReminderIcon: IconType = FaPaperPlane
export const InvoiceWatchOnIcon: IconType = FaClock
